import { Content, InlineResponse2001 } from 'pleinchamp-api-client';
import { useMemo } from 'react';
import { ADVERT_FORMAT_ID } from '@adverts/business/Adverts.contants';
import { insertAdvertInArray } from '@adverts/business/adverts.utils';
import { PlcApiResponseInterface } from '@api/business/api.hook';
import { Text } from '@components/Text/Text.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { buildContentCard } from '@utils/card';

function filterByServicesPlanningAndAssechement(element: Content) {
  return (
    element.slug === 'services-pleinchamp~planning-de-traitement' ||
    element.slug === 'services-pleinchamp~assechement-de-l-herbe'
  );
}

type Props = {
  serviceContent: PlcApiResponseInterface<InlineResponse2001>;
};

function MeteoPrimaryTools({ serviceContent }: Props) {
  const isSmartphone = useIsBreakpointDown(Breakpoint.s);

  const servicesList = useMemo(() => {
    const mesServices = serviceContent.data?.contents || serviceContent.initialData?.contents || [];
    const servicefiltered = mesServices.filter(filterByServicesPlanningAndAssechement);
    return servicefiltered
      ? insertAdvertInArray(
          servicefiltered.map((item) => buildContentCard(item, isSmartphone)),
          3,
          3000,
          ADVERT_FORMAT_ID.NativeAdBis
        )
      : undefined;
  }, [serviceContent]);

  return (
    <section className="wrapper-s">
      <Text
        className="plc-mb-basis plc-mb-up-m-l"
        flavour="black"
        i18nKey="meteo.primaryTools"
        tag="p"
        variant="new-h3"
      />
      <div className="grid-l-3-m-2-s-1">{servicesList}</div>
    </section>
  );
}

export { MeteoPrimaryTools };
